/**
 * Custom error class replacing redux-form's SubmissionError.
 * Preserves the `errors` shape ({ _error, ...fieldErrors }) so that
 * existing catch handlers that read `error.errors._error` continue to work.
 */
export default class FormSubmissionError extends Error {
	constructor(errors = {}) {
		super(errors._error || 'Form submission error');
		this.name = 'FormSubmissionError';
		this.errors = errors;
	}
}
